import React, { ComponentProps, useMemo } from 'react'
import getOfferFeatureIcon from 'lib/offer/getOfferFeatureIcon'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { SvgIconProps } from 'LuxKit/SvgIcon'
import getInclusionMinStayText from 'lib/offer/getInclusionMinStayText'

type BodyTextBlockProps = ComponentProps<typeof BodyTextBlock>

interface Props {
  inclusion: App.OfferInclusion
  isHighlighted?: boolean
  /**
   * @default medium
   */
  size?: BodyTextBlockProps['variant']
  format?: BodyTextBlockProps['format']
  colour?: BodyTextBlockProps['colour']
  lineClamp?: BodyTextBlockProps['lineClamp']
  /**
   * @default default
   */
  type?: 'default' | 'lux-plus'
  showMinStayDescription?: boolean
}

function OfferInclusionItem({
  inclusion,
  isHighlighted,
  size = 'medium',
  format,
  colour,
  lineClamp,
  type,
  showMinStayDescription,
}: Props) {
  const Icon = useMemo(() => getOfferFeatureIcon(inclusion.symbol), [inclusion])
  const highlighted = isHighlighted ?? inclusion.isHighlighted
  const iconColour: SvgIconProps['colour'] = type === 'lux-plus' ? 'lux-plus' : highlighted ? 'highlight-secondary' : undefined
  const minStayDescription = showMinStayDescription ? getInclusionMinStayText(inclusion) : undefined

  return <BodyTextBlock
    variant={size}
    format={format}
    colour={colour}
    lineClamp={lineClamp}
    weight={highlighted ? 'bold' : 'normal'}
    startIcon={<Icon colour={iconColour} data-symbol={inclusion.symbol} />}
  >
    {inclusion.description} {minStayDescription}
  </BodyTextBlock>
}

export default OfferInclusionItem
